import { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { Participant, Track } from "twilio-video";

import { DataTrackMessage } from "../../../../constants";
import { NotificationToast } from "../../../Generic/Toast/NotificationToast";

export default function useCustomerAllowRecord(participant: Participant) {
  const { t: translate } = useTranslation();

  useEffect(() => {
    const trackSubscribed = (track: Track) => {
      if (track.kind === "data") {
        const onReceiveMessage = (data: string) => {
          switch (data) {
            case DataTrackMessage.CUSTOMER_NOT_ALLOWED_RECORDING:
              NotificationToast.info(translate("theCustomerHasRemovedTheCallRecordingPermission"));
              break;
            case DataTrackMessage.CUSTOMER_ALLOWED_RECORDING:
              NotificationToast.info(
                translate("theCustomerAllowedTheRecordThisCallIsBeingRecordedFromNowOn")
              );
              break;
            default:
              break;
          }
        };

        track.on("message", onReceiveMessage);
      }
    };

    participant?.on("trackSubscribed", trackSubscribed);

    return () => {
      participant.off("trackSubscribed", trackSubscribed);
    };
  }, [participant]);
}
